import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { ModalTransition } from "../../../../common/components/transitions";
import StyledDialogTitle from "../../../../common/components/dialog/dialog-title";
import { commonTextFieldProps } from "../../../../common/components/textfield";
import StyledDialogActions from "../../../../common/components/dialog/dialog-actions";
import { commonButtonProps } from "../../../../common/components/buttons/sxprops";
import useUserManagementStore from "../../api/store";
import { useDeleteBizboxUser } from "../../api/hooks";
import { Handlers } from "../../api/handlers";

export const DeleteUserModal: React.FC = () => {
  const store = useUserManagementStore();
  const deleteUser = useDeleteBizboxUser();
  const handlers = new Handlers();
  const [reason, setReason] = useState<string | undefined>();
  const isValid = reason && reason.trim() !== "";

  const handleSubmit = () => {
    deleteUser.mutate(reason ?? "", {
      onSuccess() {
        store.setAnchorEl(null);
        handlers.handleCloseDeleteUserModal();
        setReason(undefined);
      },
    });
  };

  return (
    <Dialog
      maxWidth={"laptop"}
      fullWidth
      open={store.isDeleteUserModalOpen}
      slots={{ transition: ModalTransition }}
      slotProps={{
        paper: {
          sx: { borderRadius: "24px" },
        },
      }}
      keepMounted
      aria-describedby="delete-user-dialog-description"
    >
      <StyledDialogTitle
        actionType={"close"}
        title="Delete User"
        handleClose={
          deleteUser.isPending ? () => {} : handlers.handleCloseDeleteUserModal
        }
      />

      <DialogContent sx={{ minWidth: "300px", mt: "28px" }}>
        <Box sx={{ width: "100%" }}>
          <Typography color="text.secondary" sx={{ pb: "20px" }}>
            Are you sure you want to remove this user? This action won't delete
            their account permanently.
          </Typography>
          <TextField
            fullWidth
            label="Reason..."
            sx={commonTextFieldProps}
            multiline
            maxRows={3}
            value={reason ?? ""}
            onChange={(e) => setReason(e.target.value)}
          />
        </Box>
      </DialogContent>

      <StyledDialogActions>
        <Button
          disabled={deleteUser.isPending}
          onClick={handlers.handleCloseDeleteUserModal}
        >
          Cancel
        </Button>
        <Button
          loading={deleteUser.isPending}
          disabled={!isValid}
          sx={commonButtonProps}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
};
